import React from "react";
import {
  parseArticleTopicPlanning, TOPIC_SOURCE_LABELS, TOPIC_STYLE_LABELS,
} from "../../../shared/articleTopicPlanning";
import { observationTimestamp } from "../../../shared/observationTimestamp";

export default function ArticleTopicPlanningInfo({ json }: { json?: string | null }) {
  let plan;
  try { plan = parseArticleTopicPlanning(json); }
  catch { return <p className="text-sm text-amber-700">出題依據讀取失敗，請重新整理</p>; }
  if (!plan) return null;
  const brief = JSON.parse(json!);
  const currentProblem = typeof brief.coreProblem === "string" ? brief.coreProblem : plan.coreProblem;
  const referenced = new Set(plan.references.map(r => r.evidenceId));
  const formatDate = (value: string) => {
    const raw = observationTimestamp(value);
    const normalized = raw && /^\d{4}-\d\d-\d\d \d\d:/.test(raw) ? raw.replace(" ", "T") + "Z" : raw;
    return normalized ? new Date(normalized).toLocaleString("zh-TW", { timeZone: "Asia/Taipei", hour12: false }) : "時間無法讀取";
  };
  return <div className="space-y-2 text-sm" onClick={event => event.stopPropagation()}>
    <div className="flex flex-wrap gap-2">
      <span className="rounded border px-2 py-0.5">題目來源：{TOPIC_SOURCE_LABELS[plan.source]}</span>
      <span className="rounded border px-2 py-0.5">寫法：{TOPIC_STYLE_LABELS[plan.style]}</span>
    </div>
    <p><span className="font-medium">本篇要回答：</span>{currentProblem}</p>
    <p className="text-muted-foreground">出題原因：{plan.occupiedSignals.map(s => s.provider === "aio" ? "AIO" : s.provider === "chatgpt" ? "ChatGPT" : "Gemini").join("、")} 最新結果為競品佔位</p>
    <details className="rounded border p-3">
      <summary className="cursor-pointer font-medium">查看出題依據</summary>
      <div className="mt-3 space-y-3">
        <p>出題時的問題：{plan.coreProblem}</p>
        {plan.occupiedSignals.map(signal => <div key={signal.provider}>
          <p className="font-medium">{signal.provider === "aio" ? "AIO" : signal.provider === "chatgpt" ? "ChatGPT" : "Gemini"}：{signal.competitors.join("、")}</p>
          <p className="text-xs text-muted-foreground">檢查時間：{formatDate(signal.checkedAt)}（台灣時間）</p>
          <p className="mt-1">實際問句：{signal.query}</p>
        </div>)}
        {plan.evidence.filter(e => referenced.has(e.id)).map(evidence => <details key={evidence.id} className="rounded bg-muted/40 p-3">
          <summary className="cursor-pointer">{evidence.title}：展開來源原文</summary>
          {evidence.url && /^https?:\/\//i.test(evidence.url) ? <a className="mt-2 block break-all underline" href={evidence.url} target="_blank" rel="noopener noreferrer">開啟來源頁面</a> : null}
          <p className="mt-2 whitespace-pre-wrap break-words text-xs leading-6">{evidence.text}</p>
        </details>)}
        <p className="text-xs text-muted-foreground">同批已核對來源與問題差異；沒有來源的內容地圖格子留白</p>
        {plan.sourceIssues.map((issue, index) => <p key={index} className="text-xs text-amber-700">{issue}</p>)}
      </div>
    </details>
  </div>;
}
